import { Divider, Grid, Typography } from '@mui/material';
import { formatAsAsset } from '@tassat/utility';
import * as React from 'react';

import { AssetBalancesWithPrice } from 'Selectors/assetBalancesStats';

// TODO: Change multiplication calculation here for proper truncation and large number handling
export const renderSecurityStats = (
    securityStat: AssetBalancesWithPrice,
    classes
) => {
    const securityPrice = Number(securityStat.security?.Price);

    return (
        <React.Fragment key={securityStat.AssetId}>
            <Grid
                container
                direction='column'
                item
            >
                <Typography className={classes.detailsHeader}>{securityStat.security?.Ticker}</Typography>
                <Divider className={classes.headerDivider} />
                <Grid
                    alignItems='center'
                    className={classes.detailsBox}
                    container
                    direction='row'
                    item
                    key={`row-detail-${1}`}
                    wrap='nowrap'
                >
                    <Grid
                        container
                        direction='column'
                    >
                        <Typography className={classes.detailsTitle}>Today&apos;s Buys via API:</Typography>
                        <Typography
                            className={classes.detailsValue}
                            component='div'
                        >
                            {formatAsAsset(securityStat.TodaysBuyAmount, securityStat.security, 'ticker', undefined, true)}
                            <Divider />
                            {securityStat.TodaysBuyAmount !== undefined ?
                                <Typography className={classes.detailsEquivalent}>
                                    {formatAsAsset((Number(securityStat.TodaysBuyAmount) * securityPrice), securityStat.currency, 'symbol')}
                                </Typography> : ''}
                        </Typography>
                    </Grid>
                    <Grid
                        alignItems='center'
                        container
                        item
                    >
                        <Typography className={`${classes.detailsTitle} ${classes.transactionTitle}`}>Transactions:</Typography>
                        <Typography
                            className={`${classes.transactionsBox} ${classes.bgBlue}`}
                        >
                            {securityStat.TodaysBuyCount}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    alignItems='center'
                    className={classes.detailsBox}
                    container
                    direction='row'
                    item
                    key={`row-detail-${2}`}
                    wrap='nowrap'
                >
                    <Grid
                        container
                        direction='column'
                    >
                        <Typography className={classes.detailsTitle}>Today&apos;s Subscriptions via API:</Typography>
                        <Typography
                            className={classes.detailsValue}
                            component='div'
                        >
                            {formatAsAsset(securityStat.TodaysSubscriptionsAmount, securityStat.security, 'ticker', undefined, true)}
                            <Divider />
                            {securityStat.TodaysSubscriptionsAmount !== undefined ?
                                <Typography className={classes.detailsEquivalent}>
                                    {formatAsAsset((Number(securityStat.TodaysSubscriptionsAmount) * securityPrice), securityStat.currency, 'symbol')}
                                </Typography> : ''}
                        </Typography>
                    </Grid>
                    <Grid
                        alignItems='center'
                        container
                        item
                    >
                        <Typography className={`${classes.detailsTitle} ${classes.transactionTitle}`}>Transactions:</Typography>
                        <Typography
                            className={`${classes.transactionsBox} ${classes.bgLightBlue}`}
                        >
                            {securityStat.TodaysSubscriptionsCount}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    alignItems='center'
                    className={classes.detailsBox}
                    container
                    direction='row'
                    item
                    key={`row-detail-${3}`}
                    wrap='nowrap'
                >
                    <Grid
                        container
                        direction='column'
                    >
                        <Typography className={classes.detailsTitle}>Today&apos;s Sells via API:</Typography>
                        <Typography
                            className={classes.detailsValue}
                            component='div'
                        >
                            {formatAsAsset(securityStat.TodaysSellAmount, securityStat.security, 'ticker', undefined, true)}
                            <Divider />
                            {securityStat.TodaysSellAmount !== undefined ?
                                <Typography className={classes.detailsEquivalent}>
                                    {formatAsAsset((Number(securityStat.TodaysSellAmount) * securityPrice), securityStat.currency, 'symbol')}
                                </Typography> : ''}
                        </Typography>
                    </Grid>
                    <Grid
                        alignItems='center'
                        container
                        item
                    >
                        <Typography className={`${classes.detailsTitle} ${classes.transactionTitle}`}>Transactions:</Typography>
                        <Typography
                            className={`${classes.transactionsBox} ${classes.bgBlue}`}
                        >
                            {securityStat.TodaysSellCount}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    alignItems='center'
                    className={classes.detailsBox}
                    container
                    direction='row'
                    item
                    key={`row-detail-${4}`}
                    wrap='nowrap'
                >
                    <Grid
                        container
                        direction='column'
                    >
                        <Typography className={classes.detailsTitle}>Today&apos;s Redemptions via API:</Typography>
                        <Typography
                            className={classes.detailsValue}
                            component='div'
                        >
                            {formatAsAsset(securityStat.TodaysRedemptionsAmount, securityStat.security, 'ticker', undefined, true)}
                            <Divider />
                            {securityStat.TodaysRedemptionsAmount !== undefined ?
                                <Typography className={classes.detailsEquivalent}>
                                    {formatAsAsset((Number(securityStat.TodaysRedemptionsAmount) * securityPrice), securityStat.currency, 'symbol')}
                                </Typography> : ''}
                        </Typography>
                    </Grid>
                    <Grid
                        alignItems='center'
                        container
                        item
                    >
                        <Typography className={`${classes.detailsTitle} ${classes.transactionTitle}`}>Transactions:</Typography>
                        <Typography
                            className={`${classes.transactionsBox} ${classes.bgLightBlue}`}
                        >
                            {securityStat.TodaysRedemptionsCount}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    alignItems='center'
                    className={classes.detailsBox}
                    container
                    direction='row'
                    item
                    key={`row-detail-${5}`}
                    wrap='nowrap'
                >
                    <Grid
                        container
                        direction='column'
                    >
                        <Typography className={classes.detailsTitle}>Today&apos;s Sends via API:</Typography>
                        <Typography
                            className={classes.detailsValue}
                            component='div'
                        >
                            {formatAsAsset(securityStat.TodaysSendAmount, securityStat.security, 'ticker', undefined, true)}
                            <Divider />
                            {securityStat.TodaysSendAmount !== undefined ?
                                <Typography className={classes.detailsEquivalent}>
                                    {formatAsAsset((Number(securityStat.TodaysSendAmount) * securityPrice), securityStat.currency, 'symbol')}
                                </Typography> : ''}
                        </Typography>
                    </Grid>
                    <Grid
                        alignItems='center'
                        container
                        item
                    >
                        <Typography className={`${classes.detailsTitle} ${classes.transactionTitle}`}>Transactions:</Typography>
                        <Typography
                            className={`${classes.transactionsBox} ${classes.bgBlue}`}
                        >
                            {securityStat.TodaysSendCount}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export const renderCurrencyStats = (
    currencyStatistic: AssetBalancesWithPrice,
    classes
) => {
    return (
        <React.Fragment key={currencyStatistic.AssetId}>
            <Grid
                container
                direction='column'
                item
            >
                <Typography className={classes.detailsHeader}>{currencyStatistic.currency?.Curcode}</Typography>
                <Divider className={classes.headerDivider} />
                <Grid
                    alignItems='center'
                    className={classes.detailsBox}
                    container
                    direction='row'
                    item
                    key={`row-detail-${1}`}
                    wrap='nowrap'
                >
                    <Grid
                        container
                        direction='column'
                    >
                        <Typography className={classes.detailsTitle}>Today&apos;s Withdrawals via API:</Typography>
                        <Typography
                            className={classes.detailsValue}
                            component='div'
                        >
                            {formatAsAsset(currencyStatistic.TodaysWithdrawalAmount, currencyStatistic.security, 'symbol', undefined, true)}
                        </Typography>
                    </Grid>
                    <Grid
                        alignItems='center'
                        container
                        item
                    >
                        <Typography className={`${classes.detailsTitle} ${classes.transactionTitle}`}>Transactions:</Typography>
                        <Typography
                            className={`${classes.transactionsBox} ${classes.bgBlue}`}
                        >
                            {currencyStatistic.TodaysWithdrawalCount}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    alignItems='center'
                    className={classes.detailsBox}
                    container
                    direction='row'
                    item
                    key={`row-detail-${2}`}
                    wrap='nowrap'
                >
                    <Grid
                        container
                        direction='column'
                    >
                        <Typography className={classes.detailsTitle}>Today&apos;s Sends via API:</Typography>
                        <Typography
                            className={classes.detailsValue}
                            component='div'
                        >
                            {formatAsAsset(currencyStatistic.TodaysSendAmount, currencyStatistic.security, 'symbol', undefined, true)}
                        </Typography>
                    </Grid>
                    <Grid
                        alignItems='center'
                        container
                        item
                    >
                        <Typography className={`${classes.detailsTitle} ${classes.transactionTitle}`}>Transactions:</Typography>
                        <Typography
                            className={`${classes.transactionsBox} ${classes.bgLightBlue}`}
                        >
                            {currencyStatistic.TodaysSendCount}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};